const requestIdleOrAnimationFrame = () => {
  return window.requestIdleCallback ||
    window.requestAnimationFrame ||
    window['mozRequestAnimationFrame'] ||
    (window as any).webkitRequestAnimationFrame ||
    window['msRequestAnimationFrame'];
}

export function withRequestIdleCallbackAsync<T extends (...args: any[]) => Promise<any>>(
  target: any,
  propertyName: string,
  descriptor: TypedPropertyDescriptor<T>
): TypedPropertyDescriptor<T> | void {
  const originalMethod = descriptor.value;

  if (originalMethod) {
    descriptor.value = async function (this: ThisParameterType<T>, ...args: Parameters<T>): Promise<ReturnType<T>> {
      return new Promise((resolve) => {
        const callback = requestIdleOrAnimationFrame();
        callback(async () => {
          const result = await originalMethod.apply(this, args);
          resolve(result);
        });
      });
    } as T;
  }

  return descriptor;
}

export function withRequestIdleCallback<T extends (...args: any[]) => any>(
  target: any,
  propertyName: string,
  descriptor: TypedPropertyDescriptor<T>
): TypedPropertyDescriptor<T> | void {
  const originalMethod = descriptor.value;

  if (originalMethod) {
    descriptor.value = function (this: ThisParameterType<T>, ...args: Parameters<T>): ReturnType<T> {
      let result: ReturnType<T>;
      const callback = requestIdleOrAnimationFrame();
      callback(() => {
        result = originalMethod.apply(this, args);
      });
      return result; // Be mindful of this return value
    } as T;
  }

  return descriptor;
}